import { COST_CENTER_COUNTER } from 'utils/constants'

const costCenterCounterStorage = localStorage.getItem(COST_CENTER_COUNTER)
const state = costCenterCounterStorage
  ? { counter: Number(costCenterCounterStorage) }
  : { counter: null }

const actions = {
  set ({ commit }, payload) {
    commit('set', payload)
  },

  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  set (state, payload) {
    state.counter = payload
  },

  clear (state) {
    state.counter = null
  }
}

const costCenter = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default costCenter
